import React, { useEffect } from 'react';
import './Notification.css';

export type AdminNoticeKind = 'success' | 'error' | 'info';

interface NotificationProps {
  kind?: AdminNoticeKind;
  title?: string;
  message: string;
  durationMs?: number;
  onClose?: () => void;
}

const iconFor = (kind: AdminNoticeKind) => {
  switch (kind) {
    case 'success': return '✓';
    case 'error': return '!';
    default: return 'i';
  }
};

const Notification: React.FC<NotificationProps> = ({
  kind = 'info',
  title,
  message,
  durationMs = 4000,
  onClose,
}) => {
  useEffect(() => {
    const t = setTimeout(() => { onClose && onClose(); }, durationMs);
    return () => clearTimeout(t);
  }, [durationMs, onClose]);

  return (
    <div className="adm-notification-wrapper">
      <div className={`adm-notification adm-notification-${kind}`}>        
        <div className="adm-notification-icon" aria-hidden="true">{iconFor(kind)}</div>
        <div className="adm-notification-content">
          {title && <div className="adm-notification-title">{title}</div>}
          <div className="adm-notification-message">{message}</div>
        </div>
        <button
          type="button"
          className="adm-notification-close"
          aria-label="Close notification"
          onClick={onClose}
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default Notification;
